import { addMinutes, differenceInMinutes, format, setHours } from "date-fns";
import { useObservableState } from "observable-hooks";
import React, { useEffect, useRef } from "react";
import { Appointment } from "shared";
import { Rx } from "../../../../../prelude";

interface AppointmentProps {
  id: string;
  title: string;
  startTime: Date;
  endTime: Date;
  overlapCount: number;
  position: number;
}

const HOUR_HEIGHT = 240; // Height in pixels for an hour block

const AppointmentView: React.FC<AppointmentProps> = ({
  title,
  startTime,
  endTime,
  overlapCount,
  position,
}) => {
  const duration = differenceInMinutes(endTime, startTime);
  const appointmentHeight = (duration / 60) * HOUR_HEIGHT;
  const width = 100 / overlapCount;
  return (
    <div
      className="absolute bg-blue-200 rounded-md p-2 text-xs opacity-40"
      style={{
        top: `${
          (differenceInMinutes(startTime, setHours(startTime, 0)) / 60) *
          HOUR_HEIGHT
        }px`,
        height: `${appointmentHeight}px`,
        width: `${width}%`,
        left: `${position * width}%`,
      }}
    >
      <div className="font-bold">{title}</div>
      <div>
        {format(startTime, "p")} - {format(endTime, "p")}
      </div>
    </div>
  );
};

type DayViewCalendarProps = {
  // currentDay$: Rx.BehaviorSubject<Date>;
  appointmentsForCurrentDay$: Rx.Observable<Appointment[]>;
};
export const DayViewCalendar: React.FC<DayViewCalendarProps> = ({
  appointmentsForCurrentDay$,
}) => {
  const appointments = useObservableState(appointmentsForCurrentDay$, []);

  const hours = Array.from({ length: 24 }, (_, index) =>
    setHours(new Date(), index)
  );

  const containerRef = useRef<HTMLDivElement>(null);

  // Step 2: Adjust scrollTop to start at 8 AM
  useEffect(() => {
    if (containerRef.current) {
      const startHour = 8; // The hour you want to start at
      const scrollTopValue = startHour * HOUR_HEIGHT;
      containerRef.current.scrollTop = scrollTopValue;
    }
  }, []);

  return (
    <div className="flex flex-col h-screen overflow-auto" ref={containerRef}>
      {/* <div className="text-lg font-semibold text-center py-4">
        {format(new Date(), "EEEE, MMMM d, yyyy")}
      </div> */}
      <div className="relative">
        {hours.map((hour, index) => (
          <div
            key={index}
            className="border-t border-gray-300 flex items-center pl-2"
            style={{
              height: `${HOUR_HEIGHT}px`,
            }}
          >
            {format(hour, "ha")}
          </div>
        ))}
        {appointments.map((appointment) => (
          <AppointmentView
            id={appointment.id}
            key={appointment.id}
            title={appointment.title}
            startTime={appointment.date}
            endTime={addMinutes(
              appointment.date,
              appointment.durationInMinutes ?? 0
            )}
            overlapCount={1}
            position={0}
          />
        ))}
      </div>
    </div>
  );
};
